import { KambiBetOffer } from '@mobi/api-types/kambi'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface KambiState {
  isClientVisible: boolean
  isBetslipVisible: boolean
  isLoggedIn: boolean
  isBetslipMaximized: boolean
  logoutToken: string | null
  isLoginPending: boolean
  isKambiRendered: boolean
  playerSessionId?: string
  isBrowserSupported: boolean
  outcomeIdsInBetslip: OutcomeId[]
  activeJurisdiction: 'rwwawa' | 'rwwasa' | null
}

export const initialState: KambiState = {
  isClientVisible: false,
  isBetslipVisible: false,
  isLoggedIn: false,
  isBetslipMaximized: false,
  logoutToken: null,
  isLoginPending: false,
  isKambiRendered: false,
  isBrowserSupported: true,
  outcomeIdsInBetslip: [],
  activeJurisdiction: null,
}

const kambiSlice = createSlice({
  name: 'kambi',
  initialState,
  reducers: {
    setKambiClientVisibility(state, action: PayloadAction<boolean>) {
      state.isClientVisible = action.payload
    },

    setKambiBetslipVisibility(state, action: PayloadAction<boolean>) {
      state.isBetslipVisible = action.payload
    },

    setIsKambiLoginPending(state, action: PayloadAction<boolean>) {
      state.isLoginPending = action.payload
    },

    loggedInKambiPlayer(state, action: PayloadAction<string>) {
      state.isLoggedIn = true
      state.logoutToken = action.payload
      state.isLoginPending = false
    },

    loggedOutKambiPlayer(state) {
      state.isLoggedIn = false
      state.logoutToken = null
      state.isLoginPending = false
    },

    updateBetslipMaximized(state, action: PayloadAction<boolean>) {
      state.isBetslipMaximized = action.payload
    },

    updateUserData(state, action: PayloadAction<string>) {
      state.playerSessionId = action.payload
    },

    removeKambiSpinner(state) {
      state.isKambiRendered = true
    },

    setUnsupportedBrowser(state) {
      state.isBrowserSupported = false
      state.isKambiRendered = true
    },

    setOutcomeIdsInBetslip(state, action: PayloadAction<OutcomeId[]>) {
      if ([...action.payload].sort().join('.') === [...state.outcomeIdsInBetslip].sort().join(''))
        return
      state.outcomeIdsInBetslip = action.payload
    },

    setActiveKambiJurisdiction(state, action: PayloadAction<'rwwawa' | 'rwwasa'>) {
      state.activeJurisdiction = action.payload
    },
  },
})

export const {
  setKambiClientVisibility,
  setKambiBetslipVisibility,
  setIsKambiLoginPending,
  loggedInKambiPlayer,
  loggedOutKambiPlayer,
  updateBetslipMaximized,
  updateUserData,
  removeKambiSpinner,
  setUnsupportedBrowser,
  setOutcomeIdsInBetslip,
  setActiveKambiJurisdiction,
} = kambiSlice.actions

export default kambiSlice.reducer

// =====
// Types
// =====

type OutcomeId = KambiBetOffer['outcomes'][0]['id']
